import { connect } from 'react-redux';
import { showErrorFlag } from '@helpcenter/flags';
import MultiServicePicker from './multi-service-picker';

export default connect(null, {
    showErrorFlag,
})(MultiServicePicker);
